import { slicks } from './wc_block_scripts.js';
import { init_variation, init_product_info } from './wc-product.js';
import quantity_btn_functionality from './wc_product_quantity.js';
import wc_quantity_buttons from './wc_quantity_buttons.js';
import wc_cart from './wc_cart_page.js';

export default function kyrktak_wc() {
  slicks();
  quantity_btn_functionality();
  init_product_info();
  wc_quantity_buttons();
  wc_cart();

  $('.product-add-to-cart .variations tr').each(function(){
    init_variation(this);
  });

}
